import React from "react";
import { Box, Flex } from "@rebass/grid";

import MainLayout from "../../layouts/main-admin-layout";
import { LoginProps } from "../../../container/admin-view/login";
import Button from "../../components/elements/button";
import { Heading } from "../../components/identity/styled-text";

const Login: React.FC<LoginProps> = ({
  loading,
  onSSOLogin
}) => {
  return (
    <MainLayout>
      <Flex justifyContent="center" mb="25px" width="100%">
        <Box width="40%" mt="25px">
          <Heading>Login</Heading>
          <Box mt="20px">
            <Button buttonText="Mit SSO anmelden" variant="dark" onClick={onSSOLogin} isLoading={loading} />
          </Box>
        </Box>
      </Flex>
    </MainLayout>
  );
};
export default Login;